module.exports = __webpack_public_path__ + "public/images/icons/paks.a512961dd7cbb932a8f488410b86130e.svg";